export default {
  SET_ROLES (state, roles) {
    state.roles = roles
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.roles.findIndex((u) => u.id === itemId)
    state.roles.splice(roleIndex, 1)
  }
}
